import { useEffect, useRef, useState } from "react";
import { Server } from "lucide-react";

const SERVICES = [
  "Started Network Manager",
  "Reached target Network",
  "Mounted /home filesystem",
  "Started User Login Management",
  "Started D-Bus System Message Bus",
  "Started Authentication Service",
  "Started OpenSSH server daemon",
  "Started GNOME Display Manager",
  "Started HMG Linux Lab services",
  "Reached target Graphical Interface",
];

const reduce = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default function LinuxBootScreen({ onComplete }) {
  const [lines, setLines] = useState([]);
  const [done, setDone] = useState(false);
  const timers = useRef([]);
  const doneCb = useRef(onComplete);
  doneCb.current = onComplete;

  useEffect(() => {
    let t = reduce ? 60 : 220;
    SERVICES.forEach((s, i) => {
      const jitter = reduce ? 30 : 110 + Math.random() * 150;
      t += jitter;
      timers.current.push(setTimeout(() => setLines((l) => [...l, s]), t));
    });
    timers.current.push(setTimeout(() => setDone(true), t + 300));
    timers.current.push(setTimeout(() => doneCb.current && doneCb.current(), t + 800));
    return () => timers.current.forEach(clearTimeout);
  }, []);

  return (
    <div className="fixed inset-0 z-50 bg-black text-white flex flex-col items-center justify-center gdm-fade" data-testid="linux-boot-screen">
      <div className="flex flex-col items-center mb-10">
        <div className="h-16 w-16 rounded-2xl bg-[#0f1115] border border-white/10 grid place-items-center shadow-[0_0_40px_rgba(56,189,248,0.15)]">
          <Server className="h-8 w-8 text-[#38bdf8]" />
        </div>
        <div className="mt-4 font-display text-xl font-bold tracking-tight">HMG Linux Lab</div>
        <div className="text-xs text-white/40 mt-1">HMG Global Consults · Linux Training Environment</div>
      </div>

      <div className="w-full max-w-xl px-6 font-mono text-[13px] leading-6 min-h-[220px]">
        {lines.map((s, i) => (
          <div key={i} className="flex gap-2">
            <span className="text-emerald-400">[&nbsp;&nbsp;OK&nbsp;&nbsp;]</span>
            <span className="text-white/70">{s}</span>
          </div>
        ))}
        {!done && (
          <div className="flex gap-2">
            <span className="text-white/40">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]</span>
            <span className="text-white/50">Starting HMG Linux Lab services<span className="gdm-cursor">_</span></span>
          </div>
        )}
      </div>

      {/* Progress dots */}
      <div className="mt-8 flex gap-1.5" aria-hidden>
        {[0, 1, 2].map((i) => (
          <span key={i} className="h-1.5 w-1.5 rounded-full bg-[#38bdf8]/70 glow-pulse" style={{ animationDelay: `${i * 0.25}s` }} />
        ))}
      </div>
    </div>
  );
}
